import { SVButton, SVForm, SVTextInput } from '@/components/core';
import NeedAssistanceBox from '@/components/NeedAssistanceBox';
import { useResendActivationStatus } from '@/hooks/requests/useAccountActivation';
import { Card, Stack, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import showToast from '@/utils/toast';
import { useState } from 'react';
import { MESSAGES } from '@/constants/messages';

type ResendFormValues = {
  email: string;
};

export default function ActivationResend() {
  const [showCheckEmail, setShowCheckEmail] = useState(false);
  const { resendActivation, isLoadingResendActivation } =
    useResendActivationStatus();
  const formMethods = useForm<ResendFormValues>({
    defaultValues: {
      email: '',
    },
    mode: 'onBlur',
  });

  async function handleSubmit(data: ResendFormValues) {
    try {
      await resendActivation({ email: data.email });
      setShowCheckEmail(true);
    } catch {
      showToast({
        type: 'error',
        data: {
          content: MESSAGES.genericError,
        },
      });
    }
  }

  if (showCheckEmail) {
    return (
      <Card>
        <Stack spacing={2}>
          <Typography variant="h4">Check Your Email</Typography>
          <Typography>
            Please check your email for the activation link.
          </Typography>
          <NeedAssistanceBox />
        </Stack>
      </Card>
    );
  }

  return (
    <Card>
      <Stack spacing={2}>
        <Typography variant="h4">Resend Activation Link</Typography>
        <Typography>
          To get your activation link, please enter your email address.
        </Typography>
        <SVForm<ResendFormValues> methods={formMethods} onSubmit={handleSubmit}>
          <SVTextInput name="email" label="Email Address"></SVTextInput>
          <SVButton
            variant="primary"
            type="submit"
            fullWidth
            isLoading={isLoadingResendActivation}>
            Submit
          </SVButton>
        </SVForm>
        <NeedAssistanceBox />
      </Stack>
    </Card>
  );
}
